import { UIHeading4, LinkButton, IconMap16 } from '@cian/ui-kit';
import { numberToPrettyString, plural } from '@cian/utils';
import * as React from 'react';
import { connect } from 'react-redux';

import { Container } from '../../components/Container';
import { OFFER_PLURAL_VARIANTS } from '../../constants/offers';
import { SIZE_16, SIZE_60 } from '../../constants/sizes';

import { IApplicationState } from '../../types/redux';

interface IOffersHeaderOwnProps {
  isPromoSnippetEnabled?: boolean;
}

interface IOffersHeaderStoreProps {
  count: number;
  mapFullUrl: string;
}

type TOffersHeaderProps = IOffersHeaderStoreProps & IOffersHeaderOwnProps;

export const OffersHeader: React.FunctionComponent<TOffersHeaderProps> = props => {
  const { count, mapFullUrl, isPromoSnippetEnabled } = props;

  return (
    <Container
      backgroundColor="white"
      dataMark="OffersHeader"
      height={SIZE_60}
      borderColor="gray_1"
      borderStyle="solid"
      {...(isPromoSnippetEnabled ? '' : { borderBottomWidth: 0 })}
      padding={`0 ${SIZE_16}`}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      noPrint
    >
      <UIHeading4>
        Найдено {numberToPrettyString(count)} {plural(count, OFFER_PLURAL_VARIANTS)}
      </UIHeading4>

      {mapFullUrl && (
        <Container display="inline-flex" tagName="noindex" noPrint>
          <LinkButton
            href={mapFullUrl}
            target="_blank"
            size="XS"
            theme={'fill_white_primary'}
            beforeIcon={<IconMap16 color="primary_100" />}
          >
            На карте
          </LinkButton>
        </Container>
      )}
    </Container>
  );
};

export function mapStateToProps({ offersData }: IApplicationState): IOffersHeaderStoreProps {
  return {
    count: offersData.total || 0,
    mapFullUrl: offersData.mapFullUrl || '',
  };
}

export const OffersHeaderContainer = connect(mapStateToProps)(OffersHeader);
